<!-- eslint-disable max-len -->
<template>
    <div class="aboutUs">
        <section>
            <div class="logo">
                <img src="@/assets/images/my/logo.png" alt="">
                <p>当前版本：{{ currentVersion }}</p>
            </div>
            <van-divider>◇</van-divider>
            <div class="describe">
                <p>“数智石墨”是面向中建材石墨新材料有限公司总部及下属平台或企业，涵盖浮选（精粉）、球形石墨及负极材料等主要石墨业务的销售、生产、采购、仓储、物流、技术质量、账务、设备、人员等全业务链，并服务于客户方、供应商、运输商、运输司机等上下游企业和从业人员的生态链，引领企业向数字化转型迈进。</p>
                <p>“数智石墨”运用数字化工具与微服务云原生技术，打造统一集成的生产经营一体化平台，包含销售、储运、采购、仓储、技术质量、决策分析等建设，从而构建生产运营智能化、绿色发展数字化、供应链协同生态化能力，加快数据贯通、资源共享、业务协同、智能决策，推动制造升级、加速量产。</p>
            </div>
            <div class="agreement_box">
                <div class="btn_box">
                    <span @click="openClickFun('/userAgreement')">用户协议</span>
                    <span class="shu">|</span>
                    <span @click="openClickFun('/privacyPolicy')">隐私政策</span>
                </div>
                <div class="versions_box">
                    Copyright @ 2025 中建材石墨新材料有限公司. All Rights Reserved
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    // 关于我们
    name: 'about-us',
    components: {},
    props: {},
    data() {
        return {
            currentVersion: '1.0.2', // 当前版本号
        };
    },
    computed: {},
    watch: {},
    created() {
        this.$callMobile('JYTeamsNative', 'jyGetAppVersion');
        // 转发原生回调函数
        window.callback_SendAppVersion = this.callback_SendAppVersion;
    },
    mounted() {},
    destroyed() {},
    methods: {
        callback_SendAppVersion(data) {
            if (data) {
                const versionData = JSON.parse(data);
                this.currentVersion = versionData.version;
            }
        },
        openClickFun(path) {
            this.$router.isBack = 2;
            this.$router.push({ path: path });
        },
    },
};
</script>
<style lang="stylus" scoped>
.aboutUs
    height 100%
    section
        height 100%
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        .logo
            height 165rpx
            padding-top 25rpx
            text-align center
            img
                width 90rpx
                height 90rpx
            p
                font-size 12rpx
                color #979EA7
                margin-top 10rpx
        .van-divider
            margin 0
            color #F0F0F0
        .describe
            padding 5rpx 14rpx 0
            p
                font-size 14rpx
                line-height 24rpx
                color #333333
                text-indent 2rem
        .agreement_box
            width 100%
            position absolute
            left 0
            bottom 20rpx
            .btn_box
                display flex
                justify-content center
                align-items center
                span
                    color #1b69b6
                    text-decoration underline
                    &.shu
                        padding 0 8rpx
            .versions_box
                display flex
                justify-content center
                align-items center
                color #979ea7
                font-size 12rpx
                margin-top 2rpx
</style>